module.exports = __webpack_public_path__ + "img/antes_despues_263.22341071.png";